export default "__VITE_ASSET__Dk1C_QOF__"